module.exports={
    server: {
        protocol: "https",
        host: "service.psyfiers.ch",
        basePath: "/core"
    },
}
